import React, { useMemo } from "react";
import { useTheme } from "styled-components";
import EditableText from "../inline-edit/EditableText";
import { Error, Success, Warning } from "../icons/StandardIcons";
import { Container, IconContainer, IconTitleWrapper, Title } from "../styled";
import TextEdit from "../TextEdit";

const ICON_BASED_ON_DESIGN = {
  warning: Warning,
  success: Success,
  error: Error,
};
function Standard({ data, isEditable, isTemplate }) {
  const theme = useTheme();

  const { borderRadius, accentColor, textColor, design, displayElements } =
    data;

  const Icon = useMemo(() => ICON_BASED_ON_DESIGN[design], [design]);

  return (
    <Container bgClr={accentColor[theme.name]} radius={borderRadius}>
      <IconTitleWrapper
        align={displayElements.includes("title") ? "center" : "flex-start"}
      >
        {displayElements.includes("icon") && (
          <IconContainer>
            <Icon color={textColor[theme.name]} />
          </IconContainer>
        )}
        {displayElements.includes("title") ? (
          <Title clr={textColor[theme.name]}>
            <EditableText data={data} isEditable={isEditable} field="title" />
          </Title>
        ) : (
          <>
            {displayElements.includes("text") && (
              <TextEdit
                data={data}
                textColor={textColor[theme.name]}
                isEditable={isEditable}
                isTemplate={isTemplate}
              />
            )}
          </>
        )}
      </IconTitleWrapper>

      {displayElements.includes("text") &&
        displayElements.includes("title") && (
          <TextEdit
            data={data}
            textColor={textColor[theme.name]}
            isEditable={isEditable}
            isTemplate={isTemplate}
          />
        )}
    </Container>
  );
}

export default Standard;
